<app-cheader></app-cheader>
<div class="container1">
  <main class="main-content" style="background-color: #ffffff!important;">
    <div class="custom-container1">
      <div class="d-flex justify-content-center" style="margin-bottom: 20px;margin-top:-10px;">
        <div class="navigation custom-tabs">
          <div class="tab"
            [ngClass]="{ 'active': isTabActive('/cgy/brd') || isTabActive('/cgy/ra')|| isTabActive('/cgy/cr') || isTabActive('/cgy/userstory') || isTabActive('/cgy/sdd') || isTabActive('/cgy/apigen') || isTabActive('/cgy/codegen') || isTabActive('/cgy/tcggen') }"
            routerLinkActive="active-link" routerLink="/cgy/brd">
            <a data-toggle="tab" href="#home">
              <img src="assets/CGL/NewLandingimages/wbrd.png" width="30" height="30" alt="Group2" />
              Build your project
            </a>
          </div>

          <div class="tab" [ngClass]="{ 'active': isTabActive('/cgy/ai-assist') }" routerLinkActive="active-link"
            routerLink="/cgy/ai-assist">
            <a data-toggle="tab" href="#menu1">
              <img src="assets/CGL/NewLandingimages/waiassist.png" width="30" height="30" alt="Stars" />
              AI Assist
            </a>
          </div>
          <div class="tab" [ngClass]="{ 'active': isTabActive('/cgy/codeassist') }" routerLinkActive="active-link"
            routerLink="/cgy/codeassist">
            <a data-toggle="tab" href="#menu1">
              <img src="assets/CGL/NewLandingimages/wcodeassist.png" width="30" height="30" alt="Code Assist"
                style="height:20px;" />
              Code Assist
            </a>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
<!-- ai-assist -->
<div class="fine-tune-model-container" style="background-color:#ffffff00;">

  <div class="code-box">


    <div class="main-container">

      <!-- History Container -->
      <div class="history-container" style="margin-left:4px;" [class.open]="isHistoryOpen">
        <div class="history-header" *ngIf="chatHistoryList?.chat_details?.length > 0">
          <!-- <span matTooltip="close" (click)="toggleHistory()"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-xl-heavy max-md:hidden">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.85719 3H15.1428C16.2266 2.99999 17.1007 2.99998 17.8086 3.05782C18.5375 3.11737 19.1777 3.24318 19.77 3.54497C20.7108 4.02433 21.4757 4.78924 21.955 5.73005C22.2568 6.32234 22.3826 6.96253 22.4422 7.69138C22.5 8.39925 22.5 9.27339 22.5 10.3572V13.6428C22.5 14.7266 22.5 15.6008 22.4422 16.3086C22.3826 17.0375 22.2568 17.6777 21.955 18.27C21.4757 19.2108 20.7108 19.9757 19.77 20.455C19.1777 20.7568 18.5375 20.8826 17.8086 20.9422C17.1008 21 16.2266 21 15.1428 21H8.85717C7.77339 21 6.89925 21 6.19138 20.9422C5.46253 20.8826 4.82234 20.7568 4.23005 20.455C3.28924 19.9757 2.52433 19.2108 2.04497 18.27C1.74318 17.6777 1.61737 17.0375 1.55782 16.3086C1.49998 15.6007 1.49999 14.7266 1.5 13.6428V10.3572C1.49999 9.27341 1.49998 8.39926 1.55782 7.69138C1.61737 6.96253 1.74318 6.32234 2.04497 5.73005C2.52433 4.78924 3.28924 4.02433 4.23005 3.54497C4.82234 3.24318 5.46253 3.11737 6.19138 3.05782C6.89926 2.99998 7.77341 2.99999 8.85719 3ZM6.35424 5.05118C5.74907 5.10062 5.40138 5.19279 5.13803 5.32698C4.57354 5.6146 4.1146 6.07354 3.82698 6.63803C3.69279 6.90138 3.60062 7.24907 3.55118 7.85424C3.50078 8.47108 3.5 9.26339 3.5 10.4V13.6C3.5 14.7366 3.50078 15.5289 3.55118 16.1458C3.60062 16.7509 3.69279 17.0986 3.82698 17.362C4.1146 17.9265 4.57354 18.3854 5.13803 18.673C5.40138 18.8072 5.74907 18.8994 6.35424 18.9488C6.97108 18.9992 7.76339 19 8.9 19H9.5V5H8.9C7.76339 5 6.97108 5.00078 6.35424 5.05118ZM11.5 5V19H15.1C16.2366 19 17.0289 18.9992 17.6458 18.9488C18.2509 18.8994 18.5986 18.8072 18.862 18.673C19.4265 18.3854 19.8854 17.9265 20.173 17.362C20.3072 17.0986 20.3994 16.7509 20.4488 16.1458C20.4992 15.5289 20.5 14.7366 20.5 13.6V10.4C20.5 9.26339 20.4992 8.47108 20.4488 7.85424C20.3994 7.24907 20.3072 6.90138 20.173 6.63803C19.8854 6.07354 19.4265 5.6146 18.862 5.32698C18.5986 5.19279 18.2509 5.10062 17.6458 5.05118C17.0289 5.00078 16.2366 5 15.1 5H11.5ZM5 8.5C5 7.94772 5.44772 7.5 6 7.5H7C7.55229 7.5 8 7.94772 8 8.5C8 9.05229 7.55229 9.5 7 9.5H6C5.44772 9.5 5 9.05229 5 8.5ZM5 12C5 11.4477 5.44772 11 6 11H7C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H6C5.44772 13 5 12.5523 5 12Z" 
        fill="currentColor"></path>
      </svg>
    </span> -->



          <button class="BRD-btn" style="border-radius: 30px;" matTooltip="start new conversation" (click)="newChat()">
            <img src="../../../../../assets/CGL/images/ChatIcon.svg" alt="BRD" class="user-icon" />
            New Chat


          </button>
        </div>


        <!-- <div class="history-header">
      <h4>Conversations</h4>  
    </div> -->
        <div class="history-content">

          <!-- Skeleton Loader -->
          <!-- Skeleton Loader -->
          <!-- Skeleton Loader -->
          <div *ngIf="isLoading" class="skeleton-wrapper">
            <div class="skeleton-title"></div>
            <ul>
              <li *ngFor="let item of [].constructor(chatHistoryList?.chat_details?.length || 20)">
                <div class="skeleton-item"></div>
              </li>
            </ul>
          </div>

          <div *ngIf="!isLoading">

            <!-- Grouped Histories -->
            <div *ngIf="chatHistoryList?.chat_details?.length <= 0" class="no-conversations-container">
              <div class="no-conversations-content">
                <img src="assets/CGL/images/stars.png" alt="No Conversations Icon" class="no-conversations-icon" />

                <h3 class="no-conversations-title">
                  No Conversations Yet
                </h3>
                <p class="no-conversations-text">
                  Start a conversation by selecting a category and choosing a prompt or by typing your query below.
                </p>
              </div>
            </div>



            <p *ngIf="chatHistoryList?.chat_details?.length > 0" class="head">Chat history</p>
            <div *ngFor="let group of groupedHistories | keyvalue : sortGroups" class="history-group">
              <h3>{{ group.key }}</h3>
              <ul>
                <li *ngFor="let chat of group.value" [class.active]="chat.chat_id === active_chatId"
                  (click)="loadChat(chat.chat_id,chat);">
                  <div class="chat-item-content">
                    <span class="chat-title" title="{{ chat.title || 'No Title' }}">
                      {{ chat.title || 'No Title' }}
                    </span>

                    <!-- Action Buttons -->
                    <div class="chat-actions">
                      <button (click)="openModal(confirm_model,chat.chat_id,$event); $event.stopPropagation();"
                        class="delete-btn" title="Delete Chat">
                        <!-- Delete Icon -->
                        <img src="../../../../../assets/CGL/images/delete.svg" alt="BRD" class="user-icon" />

                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>


          </div>



        </div>
      </div>


      <div class="devTalk" [class.history-open]="isHistoryOpen">
        <div class="row gx-1 gy-1">
          <div class="col">
            <button *ngIf="!this.isHistoryOpen" class="history-toggle-btn" (click)="toggleHistory()">
              <!-- History Icon -->
              <span _ngcontent-ng-c3490356044="" class="icon"><svg _ngcontent-ng-c3490356044=""
                  xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                  <path _ngcontent-ng-c3490356044="" fill="currentColor"
                    d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z">
                  </path>
                </svg></span>
              <span>History</span>
            </button>

            <!-- Sidenav -->
            <!-- <nav id="sidenav-1" data-mdb-sidenav-init class="sidenav" data-mdb-hidden="false">
    <ul class="sidenav-menu">
      <li class="sidenav-item">
        <a class="sidenav-link">
          <i class="far fa-smile fa-fw me-3"></i><span>Link 1</span></a>
      </li>
      <li class="sidenav-item">
        <a class="sidenav-link"><i class="fas fa-grin fa-fw me-3"></i><span>Category 1</span></a>
        <ul class="sidenav-collapse show">
          <li class="sidenav-item">
            <a class="sidenav-link">Link 2</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link">Link 3</a>
          </li>
        </ul>
      </li>
      <li class="sidenav-item">
        <a class="sidenav-link"><i class="fas fa-grin-wink fa-fw me-3"></i><span>Category
            2</span></a>
        <ul class="sidenav-collapse">
          <li class="sidenav-item">
            <a class="sidenav-link">Link 4</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link">Link 5</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav> -->
            <!-- Sidenav -->
            <!-- <button style="background-color: #ffffff;color:#FF4F59" data-mdb-button-init data-mdb-toggle="sidenav" data-mdb-target="#sidenav-1"
            data-mdb-ripple-init class="btn btn-primary" aria-controls="#sidenav-1" aria-haspopup="true">
            <i class="fas fa-bars"></i>
          </button> -->

            <div class="chat-section">
              <div *ngIf="!ischat" class="chat-container">
                <div class="d-flex " style="justify-content: space-around; padding-top: 25px; padding-bottom: 25px;">
                  <img src="assets/CGL/images/redstar.svg" width="56" height="57" alt="Group2" />

                </div>
                <div class="chat-header">
                  <h1 style="font: normal normal bold 32px/1px FunnelSans-Regular;color:#000000;">Hello, {{username}}
                  </h1>
                </div>
                <div class="d-flex mt-5" style="justify-content: space-around;">
                  <p class="subtitle" style="color:#6D706B ;font: normal normal bold 32px/1px FunnelSans-Regular;">How
                    can I help you today?</p>
                </div>
                <div class="chat-body">

                  <!-- <p class="description">
                    Improve developer efficiency with instant, AI-powered chat support, 
                    minimizing downtime and increasing productivity. 
                    Cut operational costs by providing quick resolutions to coding queries.
                  </p> -->

                  <!-- Button container with prompts -->
                  <div class="button-container">
                    <ng-container *ngFor="let category of promptCategories">
                      <ng-container *ngIf="!excludedCategories.includes(category.category)">
                        <button (click)="selectCategory(category); showMorePrompts()" class="btn">
                          {{ category.category }}
                        </button>
                      </ng-container>

                    </ng-container>

                  </div>
                  <div class="button-container">
                    <ng-container *ngFor="let category of promptCategories">
                      <ng-container *ngIf="excludedCategories.includes(category.category)">
                        <button (click)="selectCategory(category); showMorePrompts()" class="btn">
                          {{ category.category }}
                        </button>
                      </ng-container>

                    </ng-container>

                  </div>
                  <br>

                  <!-- Modal for displaying prompts under the selected category -->
                  <div *ngIf="viewMore" class="modal d-flex " style="padding-top: 1px;">
                    <div class="modal-content">
                      <!-- Close button on the extreme right -->
                      <span class="close" (click)="showMorePrompts()">&times;</span>

                      <!-- Conditional header based on selected category -->
                      <h2 class="modal-header">
                        {{ selectedCategory ? selectedCategory.category + ' Prompts' : 'Select a Category' }}
                      </h2>

                      <!-- Back button to go back to category selection -->
                      <!-- <button *ngIf="selectedCategory" (click)="backToCategories()" class="btn back-btn">  
                      &larr; Back to Categories  
                    </button>   -->

                      <!-- Container for prompts under the selected category -->
                      <div *ngIf="selectedCategory" class="modal-button-container">
                        <div class="category-prompts">
                          <button *ngFor="let prompt of selectedCategory.prompts"
                            (click)="setUserMessage(prompt); showMorePrompts();" class="btn">
                            {{ prompt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div *ngIf="ischat" class="chat-window" #ChatWindow>
                <div class="message">
                  <div class="user-message">
                    <!-- <div class="profile-icon">
                      <img src="../../../assets/images/aiProfile.png" alt="">
                    </div> -->








                    <!-- <div class="message-content" style="background: #fff;"> -->
                    <!-- <div class="message-text" style="color: #212529; letter-spacing: 1.2px;">Hello and welcome! I am
                        your personal Coding AI Assistant, codeGenY Lite, your Infinite Subject Matter Expert, ready to
                        assist you across all subject areas and design principles for coding. You can refer to me as
                        'codeGenY Lite' throughout our interaction. My primary mission is to craft top-notch software
                        solutions. As an expert in programming, security, documentation, and a follower of industry
                        best practices, including SOLID and DRY principles, I will diligently work on your software
                        project. I'll be sure to ask questions to gain a complete understanding of your specifications
                        before I engineer the software. No need for you to provide code – I'm here to assist you in
                        every step.</div> -->
                    <!-- </div> -->
                  </div>
                </div>
                <!-- Messages Loop -->
                <div *ngFor="let message of chatMessages;let i = index" class="message"
                  [ngClass]="{'user': message.type === 'user', 'bot': message.type === 'bot'}">
                  <!-- User Message -->
                  <div *ngIf="message.type === 'user'" class="user-message">
                    <div class="profile-icon">
                      <img src="../../../assets/CGL/images/User.png" alt="">
                    </div>

                    <div class="message-content">
                      <div *ngIf="message.file" class="file-content">
                        <div class="file-text">File name:{{ message.file }}</div>

                      </div>

                      <!-- <div class="message-text">{{ message.userMessage }}</div> -->

                      <div class="message-text" *ngIf="message.userMessage">{{ message.userMessage }}</div>
                      <div class="message-text" *ngIf="!message.userMessage">{{ message.message }}</div>
                    </div>
                  </div>
                  <!-- Bot Message -->
                  <div *ngIf="message.type === 'bot'" class="bot-message">
                    <div class="profile-icon">
                      <img src="../../../assets/CGL/images/AI-Icon.png" alt="">
                    </div>
                    <div class="message-content">
                      <div markdown lineNumbers clipboard [data]="message.message " [disableSanitizer]="true"
                        class="message-text"></div>


                      <ng-container *ngIf="message?.message">
                        <div class="user-action" *ngIf="message.type != 'user'">
                          <div [hidden]="isCopied" class="btn btn-sm" (click)="copyToClipboard(message?.message)"
                            title="Copy to clipboard">

                            <svg xmlns="http://www.w3.org/2000/svg" width="21" fill="none" viewBox="0 0 24 24"
                              class="icon-md-heavy">
                              <path fill="#474747" fill-rule="evenodd"
                                d="M7 5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-2v2a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h2zm2 2h5a3 3 0 0 1 3 3v5h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1zM5 9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z"
                                clip-rule="evenodd" />
                            </svg>
                          </div>
                          <div [hidden]="!isCopied" class="btn btn-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" fill="none" viewBox="0 0 24 24"
                              class="icon-md-heavy">
                              <path fill="#474747" fill-rule="evenodd"
                                d="M18.063 5.674a1 1 0 0 1 .263 1.39l-7.5 11a1 1 0 0 1-1.533.143l-4.5-4.5a1 1 0 1 1 1.414-1.414l3.647 3.647 6.82-10.003a1 1 0 0 1 1.39-.263"
                                clip-rule="evenodd" />
                            </svg>
                          </div>
                          <div class="btn btn-sm" (click)="regenerate(i)" title="Regenerate">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.984" height="16.004"
                              viewBox="0 0 15.984 16.004">
                              <path id="ic--round-refresh"
                                d="M17.65,6.35a7.95,7.95,0,0,0-6.48-2.31,8,8,0,1,0,8.04,11.4,1,1,0,0,0-.9-1.44.973.973,0,0,0-.88.53A5.993,5.993,0,1,1,12,6a5.915,5.915,0,0,1,4.22,1.78L14.71,9.29a1,1,0,0,0,.7,1.71H19a1,1,0,0,0,1-1V6.41a1,1,0,0,0-1.71-.71Z"
                                transform="translate(-4.016 -3.996)" fill="#474747" />
                            </svg>

                          </div>





                        </div>
                      </ng-container>

                    </div>
                  </div>




                </div>
              </div>
              <!-- Message Input Area -->
              <!-- <div class="input-area">
                <textarea [disabled]="showCustomLoader" #textarea id="textarea" class="form-control custom-control" (input)="adjustTextareaHeight($event)"
                  [(ngModel)]="userMessage" (keydown.enter)="sendMessage($event)" placeholder="Start typing here....."
                  style="resize: vertical;"
                ></textarea>
                <button class="chat-btn" (click)="sendMessage()">
                  <img *ngIf="!showCustomLoader; else loaderTemplate" src="../../../../assets/CGL/images/send.png" alt="Send">
                  <ng-template #loaderTemplate>
                    <div class="loader">
                      <div class="dots"></div>
                    </div>
                  </ng-template>
                </button>
                
               
              </div> -->
              <!-- Validation Messages -->
              <div>

              </div>
              <small class="text-danger" *ngIf="messageFormControl.hasError('minlength')">
                Message must be at least 2 characters long.
              </small>
              <small class="text-danger" *ngIf="messageFormControl.hasError('maxlength')">
                Message cannot exceed 40000 characters.
              </small>
            </div>

          </div>





        </div>

        <div class="chat-section1">



          <div class="input-container">
            <!-- File Preview Section -->
            <div class="file-preview-wrapper" *ngIf="uploadedFiles.length > 0">
              <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
                <!-- File Type Icon -->


                <!-- File Name -->
                <span class="file-name">{{ file.name }}</span>

                <!-- Remove Button -->
                <button style="background-color:transparent ; color:#ff555f;" (click)="removeFile(i)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                    viewBox="0 0 16 16">
                    <path
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                </button>
              </div>
            </div>



            <!-- Input & Buttons Section -->
            <div class="input-wrapper" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
              <!-- Left Buttons -->
              <div class="left-buttons">
                <!-- Attach File -->
                <label [title]="extension" for="fileInput" class="icon-btn">
                  <img src="../../../../../assets/CGL/images/paperclip.svg" alt="Send" height="18">

                </label>
                <input [accept]="allowedFileTypes1" type="file" id="fileInput" #fileInput
                  (change)="handleFileUpload($event)" hidden />


              </div>

              <!-- Textarea -->
              <div class="textarea-container">
                <textarea [(ngModel)]="userMessage" placeholder="Start typing here..."
                  (input)="adjustTextareaHeight($event)" (keydown.enter)="sendMessage()" rows="1"></textarea>
              </div>

              <div class="send-section">
                <!-- Send Button -->
                <button class="send-btn" (click)="sendMessage()" *ngIf="!showCustomLoader">
                  <img src="../../../../../assets/CGL/images/send.svg" alt="Send">
                </button>
              </div>
              <button style="border: none;background-color: transparent;" class="send-btn1" (click)="stopGenerating()"
                *ngIf="showCustomLoader">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#ff555f" class="bi bi-stop-circle"
                  viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path
                    d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                </svg>
              </button>
            </div>
          </div>









        </div>
        <div class="row gx-2 gy-2" class="d-flex" style="gap:10px;">
          <input type="checkbox" id="myCheckbox" name="myCheckbox" [(ngModel)]="promptgen">
          <label for="myCheckbox">Enhance your prompt</label>
        </div>
      </div>
    </div>
    <!-- Privacy Policy Dialog -->
  </div>



</div>
<!-- <br><br>  -->
<div class="chat-window" #ChatWindow1>

</div>
<!--  <br><br>  <br><br>  <br><br>   -->

<!-- Your Angular components and scripts here -->
<!-- <div *ngIf="showCustomLoader" class="overlay">
      <div class="spinner"></div>
    </div> -->
<ng-template #confirm_model>

  <div class="modal-body text-center">
    <!-- <button type="button" class="close" (click)="modalRef?.hide()">&times;</button> -->

    <p>Are you sure you want to delete this chat?</p>
    <button style="border-radius: 0px; border:none;" type="button" class="btn btn-default "
      (click)="deleteChat(this.histroyDeleteId,this.deleteid);modalRef?.hide()">Yes</button>
    <button style="border-radius: 0px;border:none;" type="button" class="btn btn-primary"
      (click)="modalRef?.hide()">No</button>
  </div>
</ng-template>

<div *ngIf="isspinner" class="overlay">
  <div class="spinner"></div>
</div>